import apiCall from '../../apiCall/apiCall';
import buildUrlSearchParams from '../../apiCall/buildUrlSearchParams/buildUrlSearchParams';

// This class handles any API calls related to QR codes.
class QrCode {
  static decode(text) {
    const params = buildUrlSearchParams({ qr: text });
    return apiCall('GET', `api/warehouses/qr_codes/decode`, params);
  }
}

export default QrCode;
